import Web3 from 'web3'
import { InftContract } from '../common'
import { isMainCurrency } from '_src/contracts/common'

// /**
//  * @description: WrappedToken合约对象
//  * @return {Object}
//  */
export const CreateWrappedTokenContract = async (contractAddress) => {
  // const contractInfo = getContractAddress('wrappedToken', 'common')

  // const chain_id = Web3.utils.numberToHex(networkId)
  // const config = { type: 'common', version: 'wrappedToken', contractAddress: contractInfo[chain_id] }
  // const contract = await InftContract(config)

  const contract = await InftContract({ type: 'common', version: 'WrappedToken', contractAddress })

  return contract
}

// 转账
export const wrappedTokenTransferFrom = async ({ address, from, to, callback }) => {
  let contractAddress = ''
  if (isMainCurrency(from.contract_addr)) {
    contractAddress = to.contract_addr
  } else {
    contractAddress = from.contract_addr
  }

  const WrappedTokenContract = await CreateWrappedTokenContract(contractAddress)

  // AAC -> WAAC  deposit
  // WAAC -> AAC  withdraw

  return new Promise((resolve, reject) => {
    if (isMainCurrency(from.contract_addr)) {
      WrappedTokenContract.methods
        .deposit()
        .send({ from: address, value: Web3.utils.toWei(from.input, 'ether') })
        .on('transactionHash', function (hash) {
          callback(hash)
        })
        .on('receipt', function (receipt) {
          resolve(receipt)
        })
        .catch((error) => {
          if (error.code === 4001) {
            reject(error)
          }
        })
    } else {
      const wad = Web3.utils.toWei(from.input, 'ether')

      WrappedTokenContract.methods
        .withdraw(wad)
        .send({ from: address })
        .on('transactionHash', function (hash) {
          callback(hash)
        })
        .on('receipt', function (receipt) {
          resolve(receipt)
        })
        .catch((error) => {
          if (error.code === 4001) {
            reject(error)
          }
        })
    }
  })
}
